import { Operation } from './types';
import type { ActionRuleGroupingModifiedChange, Change } from './types';

export function isActionRuleGroupingModifiedChange(
  change: Change,
): change is ActionRuleGroupingModifiedChange {
  const { descriptor, op } = change;
  return (
    descriptor === 'action.rules.grouping'
      && op === Operation.Modify
  );
}
